import { createContext, useContext } from "react";

export const SiteCtx = createContext(null);
export const useSite = () => useContext(SiteCtx);
